module.exports = __webpack_public_path__ + "static/media/5-Thuiskok-foto3.4cc4f823.jpg";